import React from 'react';

import { Typography } from '@mui/material';

import { numberWithCommas, sum } from '@clearverify/utils';

import { DataDisputeItemStatus } from 'src/api';

import { DashboardOverviewBlockListItem } from './DashboardOverviewBlockListItem';

type DashboardOverviewBlockDataDisputesProps = {
  lastMonthDataDisputes: Record<DataDisputeItemStatus, number>;
  loading: boolean;
};

export const DashboardOverviewBlockDataDisputes: React.FC<
  DashboardOverviewBlockDataDisputesProps
> = ({ lastMonthDataDisputes, loading }) => {
  const allDataDisputeItems = sum(...Object.values(lastMonthDataDisputes));

  return (
    <DashboardOverviewBlockListItem
      loading={loading}
      number={numberWithCommas(allDataDisputeItems)}
      title="Last Month Data Disputes"
      subtitle={
        <React.Fragment>
          <Typography component="span" variant="body2" color="success.main">{`${
            lastMonthDataDisputes[DataDisputeItemStatus.Resolved]
          } Resolved`}</Typography>
          &nbsp;and&nbsp;
          <Typography component="span" variant="body2" color="warning.main">{`${
            lastMonthDataDisputes[DataDisputeItemStatus.InProgress]
          } In progress`}</Typography>
        </React.Fragment>
      }
    />
  );
};
